import { useSelectReportData } from '../../hooks/useSelectReportData'
import '../../Report.css'
import './Page1-intro.css'

import logoImg from '../../assets/logo.png'
import darkBg from '../../assets/page-dark-bg.png'

const Page1 = () => {
  const { isNoExperiments, isNoGoals } = useSelectReportData()

  const titles = [!isNoExperiments && 'Report highlights', 'Overview', !isNoGoals && 'Your goal', 'Glucose data analysis', !isNoExperiments && "Experiments' results"].filter(Boolean)

  return (
    <div>
      <div
        className={'bg-image-config'}
        style={{
          backgroundImage: `url(${darkBg})`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: 455,
          borderRadius: '0 0 20px 20px',
          flexDirection: 'column',
        }}
      >
        <a
          target={'_blank'}
          href={'https://aspect-health.com'}
        >
          <img
            alt={'logo'}
            src={logoImg}
            style={{ width: 140, height: 20, objectFit: 'contain', marginBottom: 40 }}
          />
        </a>
        <p
          className={'title-bold inverted-text'}
          style={{ textAlign: 'center', fontSize: '2rem' }}
        >
          Your Metabolic
          <br />
          Health Report
        </p>
      </div>
      <div style={{ paddingLeft: 20, paddingRight: 20, paddingBottom: 50 }}>
        <p className='description-sub'>
          Congratulations on completing your 21-day check up! We've gathered a lot of useful and exciting information about your metabolism and converted it into helpful insights, which you can find
          below.
          <br />
          Well, let's get started!
        </p>
        <p className='subtitle'>Report structure</p>
        {titles.map((title, i) => {
          return (
            <div key={i}>
              {!!i && (
                <div className='intro-dot-line-box'>
                  <div className='intro-dot-line'></div>
                </div>
              )}
              <div className='row'>
                <div className='num-dot-item'>{i + 1}</div>
                <span className='intro-dot-text'>{title}</span>
              </div>
            </div>
          )
        })}
      </div>
      <hr />
    </div>
  )
}

export default Page1
